export class ClassName {

	public static fromEnumValue(enumValue: string): string {
		return enumValue.toLowerCase().replace(/_/g, '-');
	}

}
